import React, { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

const VisitCheckListSubtitle = ({
  subtitle,
  referesh,
  setReferesh,
  options,
}) => {
  const [selectedOption, setSelectedOption] = useState([]);

  useEffect(() => {
    subtitle.selectedOption =
      selectedOption && selectedOption[0]
        ? selectedOption[0].label
        : subtitle.selectedOption;
    subtitle.selectedOptionId =
      selectedOption && selectedOption[0]
        ? selectedOption[0]._id
        : subtitle.selectedOptionId;
    setReferesh(!referesh);
  }, [selectedOption, options]);

  return (
    <div>
      {/* <pre>{JSON.stringify(subtitle, null, 2)}</pre>
      <pre>{JSON.stringify(options, null, 2)}</pre> */}

      {options && (
        <Typeahead
          placeholder="Select or add new"
          defaultInputValue={
            options.find(
              (o) =>
                o._id.toString() === subtitle?.selectedOptionId?.toString(),
            )?.label || subtitle.selectedOption
          }
          options={options}
          onChange={(e) => setSelectedOption(e)}
          id="description"
          className="flex-grow-1"
          allowNew
          isInvalid={
            selectedOption.length === 0 && !subtitle.selectedOptionId
              ? true
              : false
          }
        />
      )}
    </div>
  );
};

export default VisitCheckListSubtitle;
